module.exports = __webpack_public_path__ + "static/media/bg-faq-epargn.87c65037.svg";